import script from "./approvedExamine.vue?vue&type=script&setup=true&lang=js"
export * from "./approvedExamine.vue?vue&type=script&setup=true&lang=js"

import "./approvedExamine.vue?vue&type=style&index=0&id=b6a52a3a&lang=scss"

const __exports__ = script;

export default __exports__